import React from 'react';
import { AppHeader } from 'src/components/ui';
import { MessageTemplate } from './messageTemplate';

export const MessageTemplateListPage: React.FC = () => {
  return (
    <AppHeader>
      <MessageTemplate />
    </AppHeader>
  );
};
